export const EXTERNAL_VIEW_STORAGE_KEY = 'ca-external-view';
export const EXTERNAL_AUTH_CONTEXT_STORAGE_KEY = 'ca-external-auth-context';
export const EMBEDDED_MODE_QUERY_PARAM = 'embedded';
export const EMBEDDED_MODE_QUERY_VALUE = 'true';

export function enableExternalView(): void {
  sessionStorage.setItem(EXTERNAL_VIEW_STORAGE_KEY, 'true');
  document.body.classList.add('external-view');
}

export function disableExternalView(): void {
  sessionStorage.removeItem(EXTERNAL_VIEW_STORAGE_KEY);
  document.body.classList.remove('external-view');
}

export function shouldUseExternalView(): boolean {
  return sessionStorage.getItem(EXTERNAL_VIEW_STORAGE_KEY) === 'true';
}

export function setExternalAuthContext(externalUrl: string): void {
  sessionStorage.setItem(EXTERNAL_AUTH_CONTEXT_STORAGE_KEY, externalUrl);
}

export function getExternalAuthContext(): string | null {
  return sessionStorage.getItem(EXTERNAL_AUTH_CONTEXT_STORAGE_KEY);
}

export function clearExternalAuthContext(): void {
  sessionStorage.removeItem(EXTERNAL_AUTH_CONTEXT_STORAGE_KEY);
}

export function hasEmbeddedModeQuery(search: string): boolean {
  return new URLSearchParams(search).get(EMBEDDED_MODE_QUERY_PARAM) === EMBEDDED_MODE_QUERY_VALUE;
}

export function appendEmbeddedMode(params: URLSearchParams, isEmbedded: boolean): void {
  if (isEmbedded) {
    params.set(EMBEDDED_MODE_QUERY_PARAM, EMBEDDED_MODE_QUERY_VALUE);
  }
}

export function resolveInternalRedirect(redirectTo: string): URL {
  const value = redirectTo?.trim();

  if (!value || value.includes('\\') || value.startsWith('//')) {
    return new URL('/', window.location.origin);
  }

  const relativePath = value.startsWith('/') ? value : `/${value}`;
  const url = new URL(relativePath, window.location.origin);

  return url.origin === window.location.origin ? url : new URL('/', window.location.origin);
}
